import React from 'react';
export const Benefits = () => {
  return <section className="py-6 sm:py-8" data-id="element-10">
      <h2 className="text-2xl font-bold text-[#E55A88] mb-5" data-id="element-11">
        How MenoBloom Works
      </h2>
      <div className="flex flex-col md:flex-row gap-6 mb-8" data-id="element-12">
        <div className="md:w-1/2 prose max-w-none text-base" data-id="element-13">
          <p data-id="element-14">
            MenoBloom contains three clinically-studied strains that restore
            balance:
          </p>
          <div className="mb-4" data-id="element-15">
            <h3 className="text-lg font-bold text-[#E55A88]" data-id="element-16">
              Lactobacillus gasseri
            </h3>
            <p data-id="element-17">Reduces belly fat and sugar cravings</p>
          </div>
          <div className="mb-4" data-id="element-18">
            <h3 className="text-lg font-bold text-[#E55A88]" data-id="element-19">
              Bifidobacterium lactis
            </h3>
            <p data-id="element-20">Produces calming GABA, improves sleep</p>
          </div>
          <div className="mb-4" data-id="element-21">
            <h3 className="text-lg font-bold text-[#E55A88]" data-id="element-22">
              Lactobacillus rhamnosus
            </h3>
            <p data-id="element-23">Boosts serotonin for mood stability</p>
          </div>
        </div>
        <div className="md:w-1/2" data-id="element-24">
          <div className="bg-[#FFF4F7] p-5 sm:p-6 rounded-md" data-id="element-25">
            <p className="font-bold mb-2" data-id="element-26">Plus supporting nutrients:</p>
            <ul className="mt-2 pl-5 space-y-2" data-id="element-27">
              <li className="flex items-start" data-id="element-28">
                <span className="text-[#E55A88] mr-2" data-id="element-29">•</span>
                <span data-id="element-30">Vitamin D3</span>
              </li>
              <li className="flex items-start" data-id="element-31">
                <span className="text-[#E55A88] mr-2" data-id="element-32">•</span>
                <span data-id="element-33">Magnesium</span>
              </li>
              <li className="flex items-start" data-id="element-34">
                <span className="text-[#E55A88] mr-2" data-id="element-35">•</span>
                <span data-id="element-36">Turmeric extract</span>
              </li>
              <li className="flex items-start" data-id="element-37">
                <span className="text-[#E55A88] mr-2" data-id="element-38">•</span>
                <span data-id="element-39">Prebiotic fiber</span>
              </li>
            </ul>
            <p className="mt-4 font-medium text-[#E55A88]" data-id="element-40">
              Everything you need in one daily capsule.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8 sm:mt-10" data-id="element-41">
        <h2 className="text-2xl font-bold text-[#E55A88] mb-5" data-id="element-42">
          Why MenoBloom Works When Others Failed
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-43">
          <div className="bg-gray-50 p-5 sm:p-6 rounded-md" data-id="element-44">
            <h3 className="text-lg font-bold text-gray-700 mb-3" data-id="element-45">
              Other products:
            </h3>
            <ul className="pl-5 space-y-2 text-sm sm:text-base" data-id="element-46">
              <li className="flex items-start" data-id="element-47">
                <span className="text-gray-500 mr-2" data-id="element-48">•</span>
                <span data-id="element-49">Treat symptoms separately</span>
              </li>
              <li className="flex items-start" data-id="element-50">
                <span className="text-gray-500 mr-2" data-id="element-51">•</span>
                <span data-id="element-52">Ignore the root cause</span>
              </li>
            </ul>
          </div>
          <div className="bg-[#FFF4F7] p-5 sm:p-6 rounded-md" data-id="element-53">
            <h3 className="text-lg font-bold text-[#E55A88] mb-3" data-id="element-54">
              MenoBloom:
            </h3>
            <ul className="pl-5 space-y-2 text-sm sm:text-base" data-id="element-55">
              <li className="flex items-start" data-id="element-56">
                <span className="text-[#E55A88] mr-2" data-id="element-57">•</span>
                <span data-id="element-58">
                  Fixes the gut-hormone connection that causes everything
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4" data-id="element-59">
          <div className="bg-gray-50 p-5 sm:p-6 rounded-md" data-id="element-60">
            <h3 className="text-lg font-bold text-gray-700 mb-3" data-id="element-61">
              Other probiotics:
            </h3>
            <ul className="pl-5 space-y-2 text-sm sm:text-base" data-id="element-62">
              <li className="flex items-start" data-id="element-63">
                <span className="text-gray-500 mr-2" data-id="element-64">•</span>
                <span data-id="element-65">Generic strains</span>
              </li>
              <li className="flex items-start" data-id="element-66">
                <span className="text-gray-500 mr-2" data-id="element-67">•</span>
                <span data-id="element-68">Low doses</span>
              </li>
              <li className="flex items-start" data-id="element-69">
                <span className="text-gray-500 mr-2" data-id="element-70">•</span>
                <span data-id="element-71">Poor survival</span>
              </li>
            </ul>
          </div>
          <div className="bg-[#FFF4F7] p-5 sm:p-6 rounded-md" data-id="element-72">
            <h3 className="text-lg font-bold text-[#E55A88] mb-3" data-id="element-73">
              MenoBloom:
            </h3>
            <ul className="pl-5 space-y-2 text-sm sm:text-base" data-id="element-74">
              <li className="flex items-start" data-id="element-75">
                <span className="text-[#E55A88] mr-2" data-id="element-76">•</span>
                <span data-id="element-77">Menopause-specific strains</span>
              </li>
              <li className="flex items-start" data-id="element-78">
                <span className="text-[#E55A88] mr-2" data-id="element-79">•</span>
                <span data-id="element-80">Clinical doses</span>
              </li>
              <li className="flex items-start" data-id="element-81">
                <span className="text-[#E55A88] mr-2" data-id="element-82">•</span>
                <span data-id="element-83">Delayed-release capsules</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};